export const phoneReg = /^(1[0-9])\d{9}$/;
export const nameReg = /^[\u4E00-\u9FA5\uf900-\ufa2d]+$/;
export const codeReg = /^\d{4}$/;
export const pwdReg = /^.{6,16}$/;
export default {
    phoneReg,
    nameReg,
    codeReg,
    pwdReg
}